<template>
  <div class="about-page">
    <div class="stripe about-container">
      <div class="container">
        <div class="about-header">
          <div class="tabs">
            <button 
              class="tab" 
              :class="{ active: activeTab === 'intro' }"
              @click="switchTab('intro')"
            >
              公司简介
            </button>
            <button 
              class="tab" 
              :class="{ active: activeTab === 'news' }"
              @click="switchTab('news')"
            >
              新闻中心
            </button>
            <button 
              class="tab" 
              :class="{ active: activeTab === 'jobs' }"
              @click="switchTab('jobs')"
            >
              工作机会
            </button>
          </div>
        </div>
        <div class="hm-card">
          <transition name="fade" mode="out-in">
            <div :key="activeTab">
              <AboutIntro v-if="activeTab === 'intro'" />
              <AboutNews v-else-if="activeTab === 'news'" />
              <AboutJobs v-else-if="activeTab === 'jobs'" />
            </div>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AboutIntro from './about/Intro.vue'
import AboutNews from './about/News.vue'
import AboutJobs from './about/Jobs.vue'

export default {
  name: 'About',
  components: {
    AboutIntro,
    AboutNews,
    AboutJobs
  },
  data() {
    return {
      activeTab: 'intro'
    }
  },
  created() {
    // 根据路由参数设置初始标签
    const path = this.$route.path
    if (path.includes('/about/hxnews')) {
      this.activeTab = 'news'
    } else if (path.includes('/about/jobs')) {
      this.activeTab = 'jobs'
    } else {
      this.activeTab = 'intro'
    }
  },
  watch: {
    // 监听路由变化
    $route(to) {
      if (to.path.includes('/about/hxnews')) {
        this.activeTab = 'news'
      } else if (to.path.includes('/about/jobs')) {
        this.activeTab = 'jobs'
      } else {
        this.activeTab = 'intro'
      }
    }
  },
  methods: {
    switchTab(tab) {
      this.activeTab = tab
      // 根据标签切换更新路由
      let routePath = '/about/intro'
      if (tab === 'news') {
        routePath = '/about/hxnews'
      } else if (tab === 'jobs') {
        routePath = '/about/jobs'
      }
      this.$router.push(routePath)
    }
  }
}
</script>

<style scoped>
.about-page {
  min-height: calc(100vh - 200px);
  padding-top: 100px; /* 添加足够的顶部内边距，避免被固定的页眉遮挡 */
}

.about-container {
  padding: 40px 0;
  background-color: #f8f9fa;
}

.about-header {
  margin-bottom: 30px;
}

.tabs {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
  background: white;
  border-radius: 8px;
  padding: 5px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.tab {
  padding: 12px 40px;
  background: none;
  border: 1px solid transparent;
  font-size: 16px;
  color: #495057;
  cursor: pointer;
  position: relative;
  transition: all 0.3s ease;
  border-radius: 6px;
  font-weight: 500;
  letter-spacing: 0.5px;
}

.tab:hover {
  background-color: #e9ecef;
  color: #2c3e50;
  border-color: #dee2e6;
  transform: translateY(-1px);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
}

.tab.active {
  color: #fff;
  background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);
  font-weight: 600;
  border-color: #0056b3;
  box-shadow: 0 4px 12px rgba(0, 123, 255, 0.3);
  transform: translateY(-1px);
}

/* 添加点击时的微动效 */
.tab:active {
  transform: translateY(0);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.hm-card {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

/* 过渡动画 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

@media (max-width: 768px) {
  .about-container {
    padding: 20px 0;
  }
  
  .tabs {
    flex-wrap: wrap;
    padding: 3px;
  }
  
  .tab {
    padding: 10px 20px;
    font-size: 14px;
    flex: 1;
    min-width: 100px;
  }
}
</style>